
<template v-if="shippingDynamicStructure[shippingLocale]">
    <div class="form-legend" v-html="`*${$t('label.required')}`"></div>
    <DynamicFields :FieldsStructure="shippingDynamicStructure[shippingLocale]" :FormName="'shipping'" />
</template>

<script setup>
import DynamicFields from "@/components/checkout/DynamicFields"
import { mapGetters } from "@/store/helper/vuex";

const { shippingDynamicStructure, shippingLocale } = mapGetters();
</script>